export const COUPON_INFLOW = {
	DEALER_CANCEL_COMPENSATION: 'DEALER_CANCEL_COMPENSATION',
	PERFORMANCE_MARKETING: 'PERFORMANCE_MARKETING',
};

export const COUPON_ERROR_CODE = {
	COUPON_ALREADY_ISSUED: 'COUPON_ALREADY_ISSUED',
	COUPON_ISSUE_DEADLINE_EXPIRED: 'COUPON_ISSUE_DEADLINE_EXPIRED',
	NOT_ELIGIBLE_TO_ISSUE_COUPON: 'NOT_ELIGIBLE_TO_ISSUE_COUPON',
	INELIGIBLE_USER_FOR_DEALER_CANCELLATION: 'INELIGIBLE_USER_FOR_DEALER_CANCELLATION',
	INELIGIBLE_USER_TYPE_FOR_PERFORMANCE_MARKETING: 'INELIGIBLE_USER_TYPE_FOR_PERFORMANCE_MARKETING',
};

export const COUPON_RESULT_TYPE = {
	SUCCESS: 'success',
	ALREADY_ISSUED: 'already_issued',
};

export const DELIVERY_COUPON_TERMS_TYPE = {
	PERSONAL_INFO_THIRD_PARTY_PROVISION: 'DELIVERY_COUPON_PERSONAL_INFO_THIRD_PARTY_PROVISION',
	EVENT_BENEFIT_EXPIRY_NOTIFICATION: 'DELIVERY_COUPON_EVENT_BENEFIT_EXPIRY_NOTIFICATION',
};

// A/B 테스트 v2 testId (환경별 분리)
export const DELIVERY_COUPON_AB_TEST_ID = {
	local: '6a8d1d5d10bea674f9623460',
	dev: '6a8d1d5d10bea674f9623460',
	qa: '6a8d1d5d10bea674f9623460',
	staging: '6a950608f817381ac5485ed2',
	prod: '6a950608f817381ac5485ed2',
};
